var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21C1 20.4477 1.44772 20 2 20H22C22.5523 20 23 20.4477 23 21C23 21.5523 22.5523 22 22 22H2C1.44772 22 1 21.5523 1 21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14C3 12.8954 3.89543 12 5 12H7C8.10457 12 9 12.8954 9 14V20C9 21.1046 8.10457 22 7 22H5C3.89543 22 3 21.1046 3 20V14ZM7 14H5V20H7V14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17C5 16.4477 5.44772 16 6 16H6.5C7.05228 16 7.5 16.4477 7.5 17C7.5 17.5523 7.05228 18 6.5 18H6C5.44772 18 5 17.5523 5 17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H19C20.1046 1 21 1.89543 21 3V20C21 21.1046 20.1046 22 19 22H9C7.89543 22 7 21.1046 7 20V3ZM19 3H9V20H19V3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5H11V7H13V5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H15V7H17V5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.5H11V10.5H13V8.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5H15V10.5H17V8.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H15V14H17V12Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5H15V17.5H17V15.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.a19ae0c40d2d7bbd015c5b097d9b8960.svg";
export { ForwardRef as ReactComponent };